import { useState } from 'react'

import { shipmentStatuses, useFetch } from '@reveni-io/reveni-ui'

import { userPermissions } from '@/common/constants'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'
import { isTrackingParcel } from '@/parcels/helpers/helpers'
import parcelServices from '@/parcels/services/services'

import getCancelParcelPayload from './helpers'

const useCancelParcel = ({ storeId, relatedId, refetchParcel, parcel, setToastInfo }) => {
  const { fetchData, loading: cancelingParcel } = useFetch(parcelServices.cancelParcel, {
    doInitialRequest: false,
  })

  const {
    data: cancellableDetail,
    fetchData: fetchCancellableDetail,
    loading: loadingCancellableDetail,
  } = useFetch(parcelServices.getCancellableDetail, { doInitialRequest: false })

  const { hasPermission } = useUserPermissions()
  const [showCancelParcelModal, setShowCancelParcelModal] = useState(false)

  const openCancelParcelModal = () => {
    setShowCancelParcelModal(true)
    fetchCancellableDetail({ storeId, relatedId })
  }

  const closeCancelParcelModal = () => {
    setShowCancelParcelModal(false)
  }

  const onCancelParcel = async selectedOption => {
    try {
      await fetchData({ storeId, relatedId, payload: getCancelParcelPayload(selectedOption) })
      await refetchParcel()
      setShowCancelParcelModal(false)
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  const allowCancelParcel =
    !isTrackingParcel(parcel) &&
    [shipmentStatuses.packed, shipmentStatuses.ready, shipmentStatuses.requested].includes(parcel?.status) &&
    hasPermission(userPermissions.cancelShipment)

  return {
    showCancelParcelModal,
    openCancelParcelModal,
    closeCancelParcelModal,
    onCancelParcel,
    cancelingParcel,
    allowCancelParcel,
    isCancellable: cancellableDetail?.is_cancellable || false,
    loadingCancellableDetail,
  }
}

export default useCancelParcel
